import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { BottomsheetModalComponent } from '../bottomsheet-modal/bottomsheet-modal.component';
import { StorageService } from 'src/app/service/storage.service';
import { ConstantService } from 'src/app/service/constant.service';

@Component({
  selector: 'app-lets-chat',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './lets-chat.component.html',
  styleUrls: ['./lets-chat.component.less']
})
export class LetsChatComponent {

  isLoggedIn: string;

  constructor(
    private _bottomSheet: MatBottomSheet,
    private storageService: StorageService,
    private constantService: ConstantService,
  ) {} 

  ngOnInit(): void {
    this.isLoggedIn = this.storageService.getItem(this.constantService.isLoggedIn);
  }

  letsChat(): void {
    try {
      this.isLoggedIn = this.storageService.getItem(this.constantService.isLoggedIn);
      if(this.isLoggedIn === this.constantService.yes) {
        window.location.href = this.constantService.letsChatBotLink;
      } else {
        this._bottomSheet.open(BottomsheetModalComponent, {
          data: { message: this.constantService.notLoggedInMessage }
        });
      }  
    } catch(e){
      console.log('Error in letsChat method - ', e);
    }
      
  }

}
